import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { WwwDirectusService, TalkDeskSetting } from 'www-cms';
import { inject } from '@angular/core';
import { forkJoin, map, switchMap } from 'rxjs';
import { Store } from '@ngxs/store';
import { HeaderActions } from './shell.state';
import dayjs from 'dayjs';

export const shouldTalkDeskBeShown = (talkDeskSetting: TalkDeskSetting) => {
  const currentDate = dayjs().tz('America/New_York');

  const dayJsStart = dayjs.utc(talkDeskSetting.startTime, 'America/New_York');
  const dayJsEnd = dayjs.utc(talkDeskSetting.endTime, 'America/New_York');

  return (
    !talkDeskSetting.specificDaysToDisable.some(({ day }) =>
      currentDate.isSame(day, 'day')
    ) &&
    talkDeskSetting.daysToShow.some((day) => +day === currentDate.day()) &&
    currentDate.isAfter(
      currentDate
        .set('hour', dayJsStart.hour())
        .set('minute', dayJsStart.minute())
    ) &&
    currentDate.isBefore(
      currentDate.set('hour', dayJsEnd.hour()).set('minute', dayJsEnd.minute())
    )
  );
};

export const shellResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot
) => {
  const directusService = inject(WwwDirectusService);
  const store = inject(Store);
  return forkJoin({
    shows: directusService.getShows(),
    bigImageLinks: directusService.getHeaderBigImageLinks(),
    headerContent: directusService.getHeaderContent(),
    footerContent: directusService.getFooterContent(),
    talkDeskSetting: directusService.getTalkDeskSetting(),
    socialLinks: directusService.getSocialLinks(),
    notificationBanners: directusService.getNotificationBanners(),
  }).pipe(
    map(
      ({
        shows,
        bigImageLinks,
        headerContent,
        footerContent,
        talkDeskSetting,
        socialLinks,
        notificationBanners,
      }) => {
        const lancasterShows = shows.filter(
          (show) => show.location?.locationCode === 'STRASBURG_PA'
        );
        const bransonShows = shows.filter(
          (show) => show.location?.locationCode === 'BRANSON_MO'
        );

        const showTalkDesk = shouldTalkDeskBeShown(talkDeskSetting);

        return {
          shows: { lancaster: lancasterShows, branson: bransonShows },
          bigImageLinks,
          headerContent,
          footerContent,
          showTalkDesk,
          socialLinks,
          notificationBanners,
        };
      }
    ),
    switchMap((shellInfo) => {
      return store
        .dispatch(new HeaderActions.SetShellInfo(shellInfo))
        .pipe(map(() => true));
    })
  );
};
